import React from 'react'
import { useQuery } from 'react-query'
import { useSelector, shallowEqual } from 'react-redux'
import { Select, SelectOption } from './Select'
import { metadataClient } from '../clients/MetadataClient'
import { selectUserToken } from '../store/user'
import { TestingKey } from '../util/testing'

type Props = {
    placeholder?: string | null
    value?: string | null
    onChange: (nextLoadTypeId: string | null) => void
    label?: string
    hasDanger?: boolean
    errorMessage?: string
    disabled?: boolean
    testingKeys?: [TestingKey] | [TestingKey, string]
    defaultFirst?: boolean
}

export const ConnectedLoadTypeSelect = (props: Props): JSX.Element => {
    const {
        value,
        label,
        hasDanger,
        errorMessage,
        placeholder: providedPlaceholder,
        disabled,
        testingKeys,
        onChange,
        defaultFirst,
    } = props
    const token = useSelector(selectUserToken, shallowEqual)
    const client = metadataClient.getLoadTypes.bind(null, {
        token: token || 'never',
    })
    const { data = {}, status } = useQuery('load-type-picker', client, {
        enabled: !!token,
    })

    const options: SelectOption[] = []

    Object.values(data).forEach((loadType) => {
        if (!loadType.id) return
        options.push({
            value: loadType.id,
            label: loadType.name,
        })
    })

    let selection = options.find((option) => option.value === value)

    if (!selection && defaultFirst) {
        selection = options?.[0]
    }

    const isLoading = status === 'loading'
    const hasErrorFetchingData = status === 'error'
    let placeholder = providedPlaceholder || 'Select...'

    if (isLoading) placeholder = 'Load types loading...'
    if (hasErrorFetchingData) placeholder = 'Something went wrong...'

    return (
        <Select
            label={label}
            disabled={disabled}
            placeholder={placeholder}
            hasDanger={hasDanger}
            error={errorMessage}
            options={options}
            onChange={onChange}
            value={selection?.value}
            testingKeys={testingKeys}
        />
    )
}
